import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../../components/Layout.js";
import { useLocation } from "react-router-dom";
import axios from "axios";
import MultiSelectCheckbox from "../../components/MultiSelectCheckbox.js";
import Select from "react-select";
import { apiFetch } from "../../api.js";

const CategoryMasterDetailsDesign = () => {
  const navigate = useNavigate();
  const [Type, setType] = useState("MainCategory");
  const [Description, setDescription] = useState("");
  const [MainCategory, setMainCategory] = useState("");
  const [MainCategoryList, setMainCategoryList] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const routerLocation = useLocation();
  const [ipAddress, setIpAddress] = useState("");
  const storedUserInfo = JSON.parse(sessionStorage.getItem("userinfo")) || {};
  const location = useLocation();
  const [editId, setEditId] = useState("");
  const [editData, setEditData] = useState(null);

  const mainCategoryOptions = MainCategoryList.map((x) => ({
    value: x.value,
    label: x.label,
  }));
  const customStyles = {
    control: (base) => ({
      ...base,
      minHeight: "40px",
      borderRadius: "5px",
      borderColor: "#ccc",
      fontSize: "14px",
    }),
  };

  const buttonContainerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "12px",
    flexWrap: "wrap",
    marginTop: "20px",
    width: "100%",
    position: "relative",
    zIndex: 10,
  };

  const buttonStyle = (bgColor) => ({
    minWidth: "120px", // ✅ same size everywhere
    height: "42px",
    padding: "0 20px",
    backgroundColor: bgColor,
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "bold",
    whiteSpace: "nowrap", // no text break
  });
  useEffect(() => {
    axios
      .get("/api/get-ip")
      .then((res) => setIpAddress(res.data.ip))
      .catch(() => setIpAddress("0.0.0.0"));
  }, []);

  useEffect(() => {
    fetchCategoryList();
  }, []);
  //--------------------------------------Categorylist Fetch
  const fetchCategoryList = async () => {
    try {
      const response = await apiFetch(
        "/api/category",
      );
      const data = await response.json();
      setMainCategoryList(data);
    } catch (error) {
      console.error("Error fetching category list:", error);
    }
  };
  //--------------------------------Save Working
  const handleSave = async () => {
    if (!Description.trim()) {
      alert("Description is required");
      return;
    }

    // ✅ ALWAYS derive NAME from ID
    const mainCategoryName =
      Type === "SubCategory" ? getMainCategoryNameById(MainCategory) : "";

    if (Type === "SubCategory" && !mainCategoryName) {
      alert("Main Category not resolved. Please reselect.");
      return;
    }

    try {
      const payload = {
        description: Description, // sp_757
        mainCategory: MainCategory, // ✅ sp_758 (NAME)
        type: Type,
        ip: ipAddress,
        userId: storedUserInfo.userId,
      };
      const response = await apiFetch(
        "/api/category/save",
        { method: "POST", body: JSON.stringify(payload) },
      );
      const data = await response.json();
      if (data.err === "0") {
        alert("Saved Successfully!");
        navigate("/CategoryMasterGrid");
      } else {
        alert(data.err);
      }
    } catch (err) {
      console.error("Save Error:", err);
      alert("Save Failed");
    }
  };

  //--------------------------------------Exit Working
  const handleExit = () => {
    navigate("/CategoryMasterGrid");
  };

  useEffect(() => {
    if (location.state?.unqid) {
      setIsEditing(true);
      loadEditData(location.state.unqid);
    }
  }, [location.state]);

  const loadEditData = async (id) => {
    try {
      const res = await apiFetch(
        `/api/category/edit/${id}`,
      );
      const data = await res.json();
      if (data) {
        setEditId(data.unqid);
        setType(data.status === 0 ? "MainCategory" : "SubCategory");
        setDescription(data.desce);

        // 🔑 SAVE edit response for later mapping
        setEditData(data);
      }
    } catch (err) {
      console.error("Edit Load Error", err);
    }
  };
  useEffect(() => {
    if (editData && editData.status === 1 && MainCategoryList.length > 0) {
      const found = MainCategoryList.find((x) => x.label === editData.type);

      setMainCategory(found ? found.value : "");
    }
  }, [editData, MainCategoryList]);

  const getMainCategoryNameById = (id) => {
    const found = MainCategoryList.find((x) => x.value === id);
    return found ? found.label : "";
  };

  const handleUpdate = async () => {
    if (!Description.trim()) {
      alert("Description is required");
      return;
    }

    const mainCategoryName =
      Type === "SubCategory"
        ? getMainCategoryNameById(MainCategory) // convert ID → NAME
        : "";

    try {
      const payload = {
        unqid: editId,
        description: Description,
        mainCategory: MainCategory, // ✅ SEND NAME
        type: Type,
        ip: ipAddress,
        userId: storedUserInfo.userId,
      };

      const response = await apiFetch(
        "/api/category/update",
        {
          method: "POST",
          body: JSON.stringify(payload),
        },
      );
      const data = await response.json();
      if (data.err === "0") {
        alert("Updated Successfully!");
        navigate("/CategoryMasterGrid");
      } else {
        alert(data.msg || data.err);
      }
    } catch (err) {
      console.error("Update Error:", err);
      alert("Update Failed");
    }
  };

  return (
    <Layout>
      <div className="page-container">
        <div className="container">
          <div className="header">Category Support</div>

          {/* ---------------- FORM ROW (NOW COMPACT & CLEAN) ---------------- */}
          <div className="form-row compact-row">
            {/* TYPE SECTION */}
            <div className="type-box">
              <label className="section-label">Type</label>

              <div className="radio-group small-radio">
                <label className="radio-item">
                  <input
                    type="radio"
                    value="MainCategory"
                    checked={Type === "MainCategory"}
                    onChange={(e) => setType(e.target.value)}
                  />
                  Main Category
                </label>

                <label className="radio-item">
                  <input
                    type="radio"
                    value="SubCategory"
                    checked={Type === "SubCategory"}
                    onChange={(e) => setType(e.target.value)}
                  />
                  Sub Category
                </label>
              </div>
            </div>

            {/* DESCRIPTION */}
            <div className="form-column">
              <label>Description</label>
              <input
                type="text"
                value={Description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>

            {/* MAIN CATEGORY */}
            <div className="form-column">
              <label>Main Category</label>
              <Select
                options={mainCategoryOptions}
                value={
                  mainCategoryOptions.find((o) => o.value === MainCategory) ||
                  null
                }
                onChange={(selected) =>
                  setMainCategory(selected ? selected.value : "")
                }
                placeholder="Select Main Category"
                styles={customStyles}
                isSearchable
              />
            </div>
          </div>

          {/* ---------------- BUTTONS ---------------- */}
          <div style={buttonContainerStyle}>
            {!isEditing && (
              <button style={buttonStyle("#4caf50")} onClick={handleSave}>
                Save
              </button>
            )}

            {isEditing && (
              <button style={buttonStyle("#2e20abff")} onClick={handleUpdate}>
                Update
              </button>
            )}

            <button style={buttonStyle("#ab2025")} onClick={handleExit}>
              Exit
            </button>
          </div>
        </div>
      </div>

      {/* ----------------------------------------------------
            CSS - YOUR ORIGINAL STYLE + IMPROVEMENTS
      ---------------------------------------------------- */}
      <style>
        {`
/* ===== PAGE LAYOUT ===== */
.page-container {
  width: 100%;
  min-height: 100vh;
  background: #f4f6f8;
  display: flex;
  justify-content: center;
  padding: 10px;
  box-sizing: border-box;
}

.container {
  width: 100%;
  max-width: 1600px;
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.08);
  box-sizing: border-box;
}

/* ===== HEADER ===== */
.header {
  text-align: center;
  font-size: 1.5rem;
  font-weight: bold;
  padding: 14px;
  background: #8B1E3F;
  color: #fff;
  border-radius: 6px;
  margin-bottom: 20px;
}

/* ===== RESPONSIVE GRID ===== */
.form-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr); /* Desktop = 4 */
  gap: 16px;
  margin-bottom: 16px;
  width: 100%;
}

/* Tablet */
@media (max-width: 1024px) {
  .form-row {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* Mobile */
@media (max-width: 600px) {
  .form-row {
    grid-template-columns: 1fr;
  }
}

/* ===== FORM ELEMENTS ===== */
.form-column {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

label {
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 4px;
}

input,
textarea,
select {
  width: 100%;
  padding: 9px 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  font-size: 14px;
  box-sizing: border-box;
}

textarea {
  resize: vertical;
  min-height: 40px;
}

/* ===== TYPE BOX ===== */
.type-box {
  display: flex;
  flex-direction: column;
}

.radio-group {
  display: flex;
  gap: 16px;
  margin-top: 6px;
}

.radio-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;
  font-size: 14px;
}

/* ===== BUTTONS ===== */
.button-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  margin-top: 20px;
  flex-wrap: wrap;
}

.button-container button {
  min-width: 120px;        /* 🔒 same width everywhere */
  height: 42px;
  padding: 0 20px;
  font-weight: 600;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  white-space: nowrap;    /* prevents text breaking */
}

/* Save */
.btn-save {
  background: #4caf50;
  color: #fff;
}

/* Exit */
.btn-exit {
  background: #a20d0d;
  color: #fff;
}

/* Update */
.btn-update {
  background: #2e20ab;
  color: #fff;
}

button:hover {
  opacity: 0.9;
}
`}
      </style>
    </Layout>
  );
};

export default CategoryMasterDetailsDesign;
